import { Component, HostListener, OnInit, inject } from '@angular/core';
import { FormService } from '../../services/form.service';
import { uniq } from 'lodash';
import { BrowserMessagesService, LoaderComponent, SideMenuHeadlineComponent } from '@rbb/ng-web-template-lib';
import { EmployeeService } from '../../services/employee.service';
import { Employee } from '../../data/employee';
import { environment } from '../../../environments/environment';
import { OverviewListItem } from '../../data/overview-list-item';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { FormsSearchPipe } from '../../pipes/forms-search.pipe';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.css'],
  imports: [RouterLink, FormsModule, NgClass, FormsSearchPipe, LoaderComponent, SideMenuHeadlineComponent]
})
export class FormsComponent implements OnInit {
  private formService = inject(FormService);
  private browserMessagesService = inject(BrowserMessagesService);
  private employeeService = inject(EmployeeService);

  width: number;
  search = '';
  selectedCategory: string | undefined;

  forms: OverviewListItem[] | undefined;
  productiveForms: OverviewListItem[] | undefined;
  categories: string[] | undefined;

  employee: Employee | undefined;

  constructor() {
    this.width = window.innerWidth;
  }

  ngOnInit(): void {
    this.getForms();
    this.getEmployeeData();
    if (!environment.dataProtectionOfficer) {
      this.getProductiveForms();
    }
  }

  getForms(): void {
    this.formService.getVisibleForms().subscribe({
      next: (data) => {
        if (data && data.length > 0) {
          this.categories = uniq(data.map(f => f.groupName)).filter(s => s).sort() as string[];
          this.selectedCategory = this.categories[0];
        } else {
          this.categories = [];
          this.selectedCategory = undefined;
        }
        this.forms = data;
      },
      error: (error) => {
        this.browserMessagesService.showHttpError(error, 'Formulare konnten nicht geladen werden');
      }
    });
  }

  getProductiveForms(): void {
    this.formService.getProductiveVisibleForms().subscribe(next => this.productiveForms = next);
  }

  isProductive(form: OverviewListItem): boolean {
    return !form.group && !!this.productiveForms?.filter(f => f.tag === form.tag || f.name === form.name).length;
  }

  getEmployeeData(): void {
    this.employeeService.getMyApprovers().subscribe(
      (data) => {
        this.employee = data;
      }
    );
  }

  selectCategory(cat: string): void {
    this.selectedCategory = cat;
    this.search = '';
  }

  @HostListener('window:resize')
  onResize(): void {
    this.width = window.innerWidth;
  }
}
